import { createContext, useContext, ReactNode } from 'react';

interface ThemeContextType {
  // Add theme properties here if needed in the future
  // For now, Tailwind handles everything via classes
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <ThemeContext.Provider value={{}}>
      <div className="min-h-screen bg-neutral-50">
        {children}
      </div>
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}



